import { apiBaseUrl } from './config';

const baseUrl = `${apiBaseUrl}/permissions`;

async function getPermissionsMatrix(token) {
  const r = await fetch(`${baseUrl}/matrix`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!r.ok) throw new Error('Error al cargar la matriz de permisos.');
  return r.json();
}

async function createPermission(token, { label, permission_key }) {
  const r = await fetch(baseUrl, {
    method: 'PUT',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ label, permission_key }),
  });
  const data = await r.json();
  if (!r.ok) throw new Error(data.message || 'Error al crear el permiso.');
  return data;
}

async function deletePermission(token, permission_id) {
  const r = await fetch(`${baseUrl}/${permission_id}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${token}` },
  });
  const data = await r.json();
  if (!r.ok) throw new Error(data.message || 'Error al eliminar el permiso.');
  return data;
}

async function setRolePermission(token, { role_id, permission_id, enabled }) {
  const r = await fetch(`${baseUrl}/matrix`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ role_id, permission_id, enabled }),
  });
  const data = await r.json();
  if (!r.ok) throw new Error(data.message || 'Error al actualizar la asignación.');
  return data;
}

export { getPermissionsMatrix, createPermission, deletePermission, setRolePermission };
